<template>
  <div>
    <card v-if="accidentStatus === 12 || accidentStatus === 14">
      <div class="row">
        <div class="col-12">
          <div v-if="accidentStatus === 12">

            <titles :text="$t('Təyinat_dəyişdirilməsi')"></titles>
            <hr width="100%" size="50"
              style="margin-top: 5px; margin-bottom: 10px; position: relative;height: 1px;background: #F3EFE0;"
              align="center">

            <el-timeline>
              <el-timeline-item v-for="(activity, index) in commUnSign" :key="index" :icon="activity.icon"
                :type="activity.type" :color="'red'" :size="activity.size"
                :timestamp="formatDateTime(activity.createDate)">
                <span style=" font-size: var(--font-primary);font-weight: bold;">{{$t('Dəyişdirən')}}: </span><span
                  style=" font-size: var(--font-primary);">{{ activity.createUserName }}</span>
                <!-- <br>
                <span style="font-size:12px;font-weight: bold;">{{$t('Dəyişdirilən')}}: </span><span
                  style="font-size:12px;">{{ activity.commUserName }}</span> -->
                <br>
                <span style=" font-size: var(--font-primary);font-weight: bold;">{{$t('Səbəb')}}: </span><span
                  style=" font-size: var(--font-primary);">{{
                  activity.reason }}</span>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div v-if="accidentStatus === 14">
            <titles :text="$t('Geri_qaytarılıb')"></titles>
            <hr width="100%" size="50"
              style="margin-top: 5px; margin-bottom: 10px; position: relative;height: 1px;background: #F3EFE0;"
              align="center">
            <el-timeline>
              <el-timeline-item v-for="(activity, index) in commReject" :key="index" :icon="activity.icon"
                :type="activity.type" :color="'#B3005E'" :size="activity.size"
                :timestamp="formatDateTime(activity.createDate)">
                <span style=" font-size: var(--font-primary);font-weight: bold;">{{$t('Geri_qaytaran')}}: </span><span
                  style=" font-size: var(--font-primary);" span>{{ activity.createUserName }}</span>
                <br>
                <span style=" font-size: var(--font-primary);font-weight: bold;">{{$t('Geri_qaytarılan')}}: </span><span
                  style=" font-size: var(--font-primary);">{{ activity.commUserName }}</span>
                <br>
                <span style=" font-size: var(--font-primary);font-weight: bold;">{{$t('Səbəb')}}: </span><span
                  style=" font-size: var(--font-primary);">{{
                  activity.reason }}</span>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
    </card>

    <div v-if="accidentStatus !== 5 && accidentStatus !== 12 && accidentStatus !== 14">
      <span style="background-color:#8E9A9B; color: white; padding:5px;">
        {{ "Qəza komissarı tərəfindən iş başlanmışdır: " + comm.createdBy }}
      </span>
      <br>
      <br>
    </div>
    <card style=" font-size: var(--font-primary) !important;">
      <titles :text="$t('İştirakçılar')"></titles>
      <hr width="100%" size="50"
        style="margin-top: 5px; margin-bottom: 5px; position: relative;height: 1px;background: #F3EFE0;" align="center">
      <div class="row">
        <div class="col-10">
          <div style="padding-bottom: 10px">
            <el-button size="small" type="primary" v-if="!isFormDisabled" @click="handleClick"
              :disabled="!comm.id || isFormDisabled"><i
                class="fa-solid fa-plus"></i>&nbsp;{{$t('Yeni_iştirakçı')}}</el-button>
          </div>
        </div>
      </div>
      <el-form v-loading="loading">
        <div class="row">
          <div class="col-md-6 col-12" v-for="item in participants" :key="item.id">
            <div v-if="item.policyType === null || item.policyType === 1">
              <participant-card :readonly="isFormDisabled" :item="item" @edit="editParticipant"
                @delete="deleteParticipant" @report="reportParticipant" @refresh="getParticipants" />
            </div>
            <div v-else>
              <other-participant-card :readonly="isFormDisabled" :item="item" @edit="editParticipant"
                @delete="deleteParticipant" @report="reportParticipant" @refresh="getParticipants" />
            </div>
          </div>
        </div>
      </el-form>

    </card>

    <div class="row">
      <div class="col-10">
      </div>

      <div class="col-2" v-if="accidentStatus === 12 && this.uid === this.commManagerUid" style="text-align: right">

        <el-button size="small" type="warning" @click="handleUser"><i class="fa-solid fa-user"></i>
          Məsul şəxsi seç </el-button>
      </div>
    </div>
    <card v-if="accidentStatus > 5 && accidentStatus !== 12 && accidentStatus !== 14">
      <div class="row">
        <div class="col-12">
          <titles :text="$t('Hadisəyə_aid_məlumat')"></titles>
          <hr width="100%" size="50" style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
            align="center">
          <!-- <h4 class="card-title">{{$t('Hadisəyə_aid_məlumat')}}</h4> -->

        </div>
        <div class="col-4" style="text-align: left" v-if="!isFormDisabled && comm">
          <el-button size="small" type="primary" @click="openChangeCommDialog">
            <i class="fa-solid fa-exchange-alt"></i>
            &nbsp;{{$t('Təyinatı_dəyiş')}}
          </el-button>
        </div>
      </div>
      <el-form :disabled="!comm.id || isFormDisabled" ref="comm" :model="comm" :label-position="labelPosition"
        :label-width="labelWidth" size="small" :rules="rules" v-loading="commloading">
        <el-form-item label-width="210px" v-if="!isFormDisabled" :label="$t('Çıxışa_ehtiyac_varmı')"
          @click.native="handleNeedDepartureClick" prop="needDeparture">
          <el-switch v-model="comm.needDeparture" :active-value="1" :inactive-value="2">
          </el-switch>
        </el-form-item>
        <div class="row">

          <div class="col-md-12 col-12">
            <el-form-item v-if="comm.needDeparture === 2" :label="$t('Hadisə_yerinə_çıxmamağın_səbəbi')" prop="departureNote">
              <el-input type="textarea" :rows="3" v-model="comm.departureNote"></el-input>
            </el-form-item>
          </div>
        </div>

        <div class="row">

          <div class="col-md-6 col-12">
            <el-form-item prop="commAccidentDate">
              <template #label>
                <label style="margin-top: 5px;">{{$t('Hadisə_vaxtı')}}</label>
              </template>
              <div class="row responsive-row">
                <div class="col-sm-12 col-md mb-2">
                  <el-date-picker disabled @change="accidentDateSave" type="date" :placeholder="$t('Tarix')"
                    format="yyyy-MM-dd" v-mask="'####-##-##'" v-model="comm.commAccidentDate"
                    :picker-options="optAccDate" style="width: 100%"></el-date-picker>
                </div>
                <div class="col-sm-12 col-md">
                  <div style="display: flex; width: 100%;">
                    <el-time-picker disabled :placeholder="$t('Vaxt')" @change="accidentDateSave" :picker-options="optAccDate"
                      v-mask="'##:##'" format="HH:mm" v-model="comm.commAccidentDate"
                      style="flex-grow: 1;"></el-time-picker>
                  </div>
                </div>

              </div>
            </el-form-item>
            <el-form-item v-if="comm.needDeparture === 1" prop="departureDate">
              <template #label>
                <label style="margin-top: 5px;">{{$t('Çıxış_vaxtı')}}
                </label>
              </template>
              <div class="row responsive-row">
                <div class="col-sm-12 col-md mb-2">
                  <el-date-picker type="date" v-mask="'####-##-##'" format="yyyy-MM-dd" :placeholder="$t('Tarix')"
                    v-model="comm.departureDate" style="width: 100%"></el-date-picker>
                </div>

                <div class="col-sm-12 col-md">
                  <div style="display: flex; width: 100%;">
                    <el-time-picker format="HH:mm" v-model="comm.departureDate" style="flex-grow: 1;"></el-time-picker>
                    <el-button size="small" :title="$t('Çıxış_vaxtını_təyin_et')" @click="onDateApprove(1)"
                      :disabled="!!comm.departureDate || comm.accidentCommUid !== uid || !canDepart" type="primary"><i
                        class="fa-solid fa-hand-pointer "></i></el-button>
                  </div>
                </div>

              </div>
            </el-form-item>
            <el-form-item :label="$t('Hadisə_yeri')" prop="commPlace">
              <el-input :disabled="isFormDisabled" v-model="comm.commPlace">
                <el-button size="small" slot="append" :title="$t('Hadisə_yerini_təyin_et')"
                  v-if="comm.needDeparture === 1 && !isFormDisabled" class="primary" icon="el-icon-location"
                  @click="() => openMap('place')"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item v-if="comm.needDeparture === 1" :label="$t('Baxış_yeri')" prop="observationPlace">
              <el-checkbox @change="onSamePlace" v-model="samePlace"
                :disabled="isFormDisabled">{{$t('Hadisə_yeri_ilə_eynidir')}}</el-checkbox>
              <el-input :disabled="isFormDisabled" v-model="comm.observationPlace">
                <el-button :title="$t('Baxış_yerini_təyin_et')" v-if="!isFormDisabled" slot="append" class="primary"
                  icon="el-icon-location" @click="() => openMap('obs')"></el-button>

              </el-input>

            </el-form-item>

            <el-form-item :label="$t('Ərazi')" prop="regionId">
              <regions v-model="comm.regionId" />
            </el-form-item>
            <el-form-item :label="$t('Zərər_vuran')" prop="victim">
              <el-select style="width: 100%" :placeholder="$t('Seçin')" v-model="comm.victim">
                <el-option :label="$t('Sığortalı')" :value="1"></el-option>
                <el-option :label="$t('Qarşı_tərəf')" :value="2"></el-option>
                <el-option :label="$t('Naməlum')" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="item.policyType!=3" :label="$t('Səbəblər')" prop="incidentCauseId">
              <incident-causes v-model="comm.incidentCauseId" v-if="item.policyType === 1" :type="1" />
              <incident-causes v-model="comm.incidentCauseId" v-if="item.policyType === 2" :type="2" />
            </el-form-item>
            <el-form-item :label="$t('Açıqlama')" prop="otherCause" v-if="comm.incidentCauseId === 14">
              <el-input v-model="comm.otherCause"></el-input>
            </el-form-item>
          </div>

          <div class="col-md-6 col-12">
            <el-form-item v-if="comm.needDeparture === 1" prop="observationDate">
              <template #label>
                <label style="margin-top: 5px;">{{$t('Baxış_vaxtı')}}
                </label>
              </template>
              <div class="row responsive-row">
                <div class="col-sm-12 col-md mb-2">
                  <el-date-picker type="date" :placeholder="$t('Tarix')" format="yyyy-MM-dd" v-mask="'####-##-##'"
                    v-model="comm.observationDate" style="width: 100%"></el-date-picker>
                </div>

                <div class="col-sm-12 col-md">
                  <div style="display: flex; width: 100%;">
                    <el-time-picker format="HH:mm" v-model="comm.observationDate"
                      style="flex-grow: 1;"></el-time-picker>
                    <el-button :title="$t('Baxış_vaxtını_təyin_et')"
                      :disabled="!!comm.observationDate || comm.accidentCommUid !== uid || !canObserve"
                      @click="onDateApprove(3)" type="primary"><i class="fa-solid fa-hand-pointer"></i></el-button>
                  </div>
                </div>

              </div>
            </el-form-item>
            <el-form-item v-if="comm.needDeparture === 1" prop="leaveDate">
              <template #label>
                <label style="margin-top: 5px;">{{$t('Ayrılma_vaxtı')}}
                </label>
              </template>
              <div class="row responsive-row">
                <div class="col-sm-12 col-md mb-2">
                  <el-date-picker type="date" v-mask="'####-##-##'" format="yyyy-MM-dd" :placeholder="$t('Tarix')"
                    v-model="comm.leaveDate" style="width: 100%"></el-date-picker>
                </div>

                <div class="col-sm-12 col-md">
                  <div style="display: flex; width: 100%;">
                    <el-time-picker format="HH:mm" v-model="comm.leaveDate" style="flex-grow: 1;"></el-time-picker>
                    <el-button size="small" :title="$t('Ayrılma_vaxtını_təyin_et')" @click="onDateApprove(2)"
                      :disabled="!!comm.leaveDate || comm.accidentCommUid !== uid || !canLeave" type="primary"><i
                        class="fa-solid fa-hand-pointer"></i></el-button>
                  </div>
                </div>

              </div>
            </el-form-item>
            <div v-if="comm.policyType && comm.policyType === 1">

              <el-form-item :label="$t('NV_sayı')" prop="vehicleCount">
                <el-input-number :disabled="comm.zbt === 1" v-model="comm.vehicleCount" :min="1" :max="10" />
              </el-form-item>
              <el-form-item :label="$t('ZBT')" prop="zbt">
                <el-radio-group @change="radioChange('zbt')"
                  :disabled="comm.commChainAccident === 1 || comm.commInjured === 1" v-model="comm.zbt">
                  <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                  <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('Zəncirvari_qəza')" prop="commChainAccident">
                <el-radio-group @change="radioChange('commChainAccident')" :disabled="comm.zbt === 1"
                  v-model="comm.commChainAccident">
                  <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                  <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('Xəsarət_alan')" prop="commInjured">
                <el-radio-group @change="radioChange('commInjured')" :disabled="comm.zbt === 1"
                  v-model="comm.commInjured">
                  <el-radio :label="1">{{$t('Var')}}</el-radio>
                  <el-radio :label="0">{{$t('Yoxdur')}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('Daxili_protokol')" prop="protocol">
                <el-radio-group @change="radioChange('protocol')" :disabled="comm.commInjured === 1"
                  v-model="comm.protocol">
                  <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                  <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-12">
            <el-form-item :label="$t('Əlavə_qeyd')" prop="departureResult">
              <el-input v-model="comm.departureResult" resize="none">
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="col-12 p-0" v-if="comm.id" style="text-align: right;">
          <el-button size="small" v-if="!isFormDisabled"
            :disabled="comm.accidentCommUid !== uid || !comm.id || isFormDisabled" type="primary" @click="saveClick"
            style="margin-left: 8px;">
            {{$t('Yadda_saxla')}}
          </el-button>

          <el-button size="small" v-if="!isFormDisabled"
            :disabled="comm.accidentCommUid !== uid || !comm.id || isFormDisabled" @click="onResetForm"
            style="margin-left: 8px;">
            {{$t('Xitam')}}
          </el-button>
        </div>
      </el-form>
      <div class="col-12 p-0" v-if="comm.id" style="text-align: right;">
        <el-button size="small" v-if="accidentStatus === 11 && roles.includes('Accident commissar manager')"
          type="success" @click="handleCommSend" style="margin-left: 8px;">
          {{$t('Müştəri_xidmətinə_göndər')}}
        </el-button>

        <el-button size="small" v-if="accidentStatus === 11 && roles.includes('Accident commissar manager')"
          type="warning" @click="openDialog" style="margin-left: 8px;">
          {{$t('Geri_qaytar')}}
        </el-button>
      </div>
      <el-form>
        <div class="row">
          <div class="col-md-12 col-12">
            <titles :text="$t('Hadisəyə_aid_fayllar')"></titles>
            <hr width="100%" size="50" style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
              align="center">
            <div style="display: flex; align-items: center;">
              <upload style="flex: 1;" :disabled="(comm.id && comm.accidentCommUid !== uid) || isFormDisabled"
                ref="upload" :sourcetype="1" :sourceId="comm.id" :autoupload="true" :acceptonlyimages="true"
                :downloadAll="true"></upload>
            </div>
          </div>
        </div>
      </el-form>


      <el-form :label-position="labelPosition" :disabled="!comm.id || isFormDisabled" :model="comm"
        :label-width="labelWidth" size="small" :rules="rules" v-loading="commloading" style="margin-top: 15px;">
        <titles :text="$t('TƏNZIMLƏNMƏ_QƏZA_KOMISSARI_MƏRHƏLƏSINDƏ_YEKUNLAŞIRSA')"></titles>
        <hr width="100%" size="50" style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
          align="center">



        <div class="row">
          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Səbəbi')" prop="finishReason">
              <finish-reasons v-model="comm.finishReason" />
            </el-form-item>

          </div>
          <div class="col-md-6 col-12">
            <el-form-item v-if="comm.finishReason" :label="$t('Tarix')" prop="finishDate">
              <el-date-picker type="datetime" :placeholder="$t('Tarix')" disabled v-model="comm.finishDate"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div v-if="comm.finishReason === 7" class="col-md-12 col-12">
            <el-form-item :label="$t('Açıqlama')" prop="otherFinishReason">
              <el-input :disabled="isFormDisabled" v-model="comm.otherFinishReason" resize="none">
              </el-input>
            </el-form-item>
          </div>
        </div>

        <div class="row">
          <div v-if="comm.finishReason !== 7 && comm.finishReason !== null" class="col-md-12 col-12">
            <el-form-item :label="$t('Qeydlər')" prop="finishNote">
              <el-input v-model="comm.finishNote" resize="none" type="textarea" :rows="2"
                :disabled="!comm.finishDate || isFormDisabled"></el-input>
            </el-form-item>
          </div>

        </div>
        <div class="col-12 d-flex flex-wrap p-0" v-if="comm.id">

          <div class="d-inline-flex gap-2 ml-auto">
            <el-button size="small"
              v-if="comm.accidentCommUid === uid && comm.finishReason && accidentStatus !== 13 && !isFormDisabled"
              type="danger" @click="rejectComm(1)">
              {{$t('Tələbdən_imtina')}}
            </el-button>
          </div>
        </div>
      </el-form>

      <div class="col-12 d-flex flex-wrap p-0" v-if="comm.id">

        <div class="d-inline-flex gap-2 ml-auto">
          <el-button size="small" v-if="accidentStatus === 13 && roles.includes('Accident commissar manager')"
            type="success" @click="openDialog()">
            {{$t('İmtinanı_ləğv_et')}}
          </el-button>
        </div>
      </div>
      <div class="col-12 d-flex flex-wrap p-0" v-if="comm.id">
        <log-changes-dialog :visible.sync="logDialogVisible" :processed-log-diffs="processedLogDiffs" />
        <record-label :created="comm.createdBy" :updated="comm.updatedBy" :show-log-button="true"
          @show-logs="showLogs(comm.id)" class="w-100 mb-2" />
      </div>
      <el-dialog :visible.sync="rejectVisible" width="30%" top="30vh" :title="$t('Səbəb')">
        <el-input size="small" v-model="comm.rejectReason" :placeholder="$t('Səbəb')"></el-input>
        <div style="height: 20px;"></div>

        <CommUsers v-model="comm.accidentCommUid" />
        <span slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="checkReasonBeforeConfirm()">{{$t('Bəli')}}</el-button>
          <el-button @click="rejectVisible = false">{{$t('Xeyr')}}</el-button>

        </span>
      </el-dialog>
      <el-dialog :visible.sync="changeCommVisible" width="30%" top="30vh" :title="$t('Təyinatı_dəyiş')">
        <CommUsers v-model="accidentCommUid" />
        <div style="height: 20px;"></div>
        <el-input size="small" v-model="comm.reason" :placeholder="$t('Səbəb')"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" type="primary"
            @click="checkChangeCommBeforeConfirm()">{{$t('Yadda_saxla')}}</el-button>
          <el-button size="small" @click="changeCommVisible = false">{{$t('İmtina')}}</el-button>

        </span>
      </el-dialog>
    </card>

    <el-collapse v-loading="loading" v-if="accidentStatus === 5 || accidentStatus === 12 || accidentStatus === 14"
      value="1">
      <el-collapse-item name="1">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-headphones-simple"></i>
            &nbsp;
            <span>{{$t('Çağrı_mərkəzinin_qeydləri')}}</span>
          </div>
        </template>

        <accident-base :value="item"></accident-base>
      </el-collapse-item>
    </el-collapse>
    <div class="row">
      <div class="col-10" style="margin-top: 15px;">
        <el-button size="small" type="warning" @click="onStart"
          v-if="accidentStatus === 5 || accidentStatus === 12 || accidentStatus === 14"><i class="fa-solid fa-play"></i>
          {{$t('Qəbul_et_və_başla')}}
        </el-button>

      </div>

      <div class="col-2" v-if="accidentStatus === 12 && this.uid === this.commManagerUid" style="text-align: right">

        <el-button size="small" type="warning" @click="handleUser"><i class="fa-solid fa-user"></i>
          Məsul şəxsi seç </el-button>
      </div>
    </div>
    <google-map ref="mapcontrol" @selected="coordChanged" />

    <participant ref="participant" @saved="getData" />
    <other-participant ref="otherParticipant" @saved="getData" />
    <report-participant ref="report" @saved="getData" />
    <comm-user @refresh="getData" ref="user" />

  </div>
</template>

<script>
  import {
    GetAccident,
    GetCommData,
    CreateCommData,
    UpdateCommData,
    GetParticipants,
    DeleteParticipant,
    SendToClientService,
    SendToCommApproval,
    CommDateUpdateByType,
    GetAccidentsByStatus,
    CommUserUpdate,
    GetCommSchedule,
    AccidentCommStart,
    SendNewAccidentToComm
  } from "../../services/accident";
  import { AccidentCommType } from "../../services/types";
  import RecordLabel from "../components/RecordLabel.vue";
  import Regions from "../components/Regions.vue";
  import IncidentCauses from '../components/IncidentCauses.vue';
  import FinishReasons from "../components/FinishReasons.vue";
  import GoogleMap from "../components/GoogleMap.vue";
  import Upload from "../components/OldUpload.vue";
  import Participant from "../components/Participant.vue";
  import OtherParticipant from "../components/OtherParticipant.vue";
  import ReportParticipant from "../components/ReportParticipant.vue";
  import ParticipantCard from "../components/ParticipantCard.vue";
  import OtherParticipantCard from "../components/OtherParticipantCard.vue";
  import CommUser from "./CommUser.vue";
  import CommUsers from "../components/CommUsers.vue";
  import AccidentBase from "../components/AccidentBase.vue";
  // import AccidentBase from "../components/AccidentBase.vue";
  import { CheckStatusCount, LastAccidentStatus, CreateCommUnSign, GetCommUnSign, GetCommReject } from "../../services/common";
  import { DateTimeToJson, DateToString, DateTimeToString, DateTimeReverseToString, labelPosition, formatDateTime } from "../../services/helper";
  import { mask } from "vue-the-mask";
  import { CommUnsign } from "../../services/types";
  import { GetFiles } from "../../services/files";
  import Titles from "../components/Titles.vue";
  import LogChangesDialog from "../components/LogChangesDialog.vue";
  import { MongoGetLogs } from "src/services/mongo";
  import { processLogDiffs } from "src/services/loghelper";

  export default {
    directives: { mask },
    props: {
      id: [String, Number],
    },
    components: {
      Titles,
      RecordLabel,
      Regions,
      GoogleMap,
      FinishReasons,
      Upload,
      Participant,
      OtherParticipant,
      ParticipantCard,
      OtherParticipantCard,
      AccidentBase,
      ReportParticipant,
      IncidentCauses,
      CommUser,
      CommUsers,
      LogChangesDialog
    },
    data() {
      return {
        loading: false,
        commloading: false,
        partloading: false,
        samePlace: null,
        rejectVisible: false,
        changeCommVisible: false,
        item: {},
        comm: {},
        participants: [],
        uid: this.$store.state.user.id,
        statusCount: 0,
        labelWidth: '210px',
        accidentStatus: null,
        commDate: { departure: null, leave: null, observation: null },
        commUnSign: [],
        commReject: [],
        commManagerUid: null,
        accidentCommUid: null,
        context: null,
        commNotification: [],
        roles: this.$store.state.user.roles,
        labelPosition: labelPosition,
        optAccDate: {
          disabledDate: (date) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > today;
          },
        },
        logs: [],
        processedLogDiffs: [],
        logDialogVisible: false,
        methodNames: ["UpdateComm"],
      };

    },
    computed: {
      isFormDisabled() {
        return (
          (this.accidentStatus >= 11 && this.accidentStatus <= 13) ||
          this.accidentStatus === 14 ||
          this.accidentStatus >= 30
        );
      },
      canObserve() {
        return this.comm.commAccidentDate !== null && this.comm.departureDate !== null;
      },
      canDepart() {
        return this.comm.commAccidentDate !== null;
      },
      canLeave() {
        return this.comm.commAccidentDate !== null && this.comm.departureDate !== null && this.comm.observationDate !== null
      },
      rules() {
        let observationDateRule = {
          required: true,
          message: this.$t('Sütunmütləqdir'),
          trigger: ["blur", "change"],
        };
        if (this.comm.needDeparture === 2) {
          observationDateRule.required = false;
        }
        return {
          commAccidentDate: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          commPlace: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          observationPlace: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          vehicleCount: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          observationDate: [observationDateRule],
          departureDate: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },

          ],
          regionId: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          victim: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          incidentCauseId: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          otherCause: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            },
          ],
          zbt: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            }
          ],
          commChainAccident: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            }
          ],
          commInjured: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            }
          ],
          protocol: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: ["blur", "change"],
            }
          ],
        }
      }
    },
    methods: {
      async showLogs(id) {
        try {
          const response = await MongoGetLogs(id, this.methodNames);
          if (!Array.isArray(response.data)) {
            this.$message.error(this.$t('Server_ilə_əlaqə_yoxdur'));
            return;
          }

          const sorted = response.data.sort((a, b) => new Date(b.Timestamp) - new Date(a.Timestamp));

          this.logs = sorted.map((log) => ({
            Timestamp: log.Timestamp,
            MethodName: log.Properties?.MethodName || '',
            RequestData: log.Properties?.RequestData.Data || {}
          }));


          this.logDialogVisible = true;
        } catch (error) {
          console.error("Log error:", error);
          this.$message.error(this.$t('Logları_çəkmək_mümkün_olmadı'));
        }
      },
      formatDateTime,
      handleNeedDepartureClick() {
        this.$nextTick(() => {
          if (this.$refs.comm) {
            this.$refs.comm.clearValidate();
          }
        });
      },
      openDialog() {
        this.rejectVisible = true;
      },

      confirm(type) {
        
        CommUserUpdate(this.id, this.comm.accidentCommUid, this.uid).then(

          (response) => {
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0]
                    ? response.data.errors[0]
                    : this.$t('Səhv_əməliyyat'),
                });
              } else {
                this.showModal = false;
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
                this.$router.push('/adm/commapprove');
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          }
        );
        this.rejectComm(type)
        this.rejectVisible = false;
      },
      onSamePlace() {
        if (this.samePlace) {

          this.comm.obsLat = this.comm.lat;
          this.comm.obsLng = this.comm.lng;
          this.comm.obsLocation = this.comm.location;
          this.comm.observationPlace = this.comm.commPlace;
        }
        else
          this.comm.observationPlace = "";
      },
      getCommUnSign() {
        GetCommUnSign(this.id).then((response) => {
          this.loading = false;
          if (response.data.isSuccess) {
            this.commUnSign = response.data.data;
          }
        });
      },
      getCommSchedule() {
        GetCommSchedule(2).then((response) => {
          this.loading = false;
          if (response.data) {
            this.commManagerUid = response.data[0].userId;
          }
        });
      },
      getCommReject() {
        GetCommReject(this.id, 2).then((response) => {
          this.loading = false;
          if (response.data) {
            this.commReject = response.data.data;
          }
        });
      },
      onDateApprove(type) {
        let typeName = '';
        if (type === 1) {
          typeName = this.$t('Çıxış');
        } else if (type === 2) {
          typeName = this.$t('Ayrılma');
        } else if (type === 3) {
          typeName = this.$t('Baxış');
        }
        this.$confirm(`${typeName} vaxtını təsdiqləyirsiz?`, this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          this.commloading = true;
          CommDateUpdateByType(this.id, type, this.uid).then((response) => {
            this.commloading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0]
                    ? response.data.errors[0]
                    : this.$t('Səhv_əməliyyat'),
                });
              } else {
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
                if (type === 1) {
                  this.comm.departureDate = new Date();
                } else if (type === 2) {
                  this.comm.leaveDate = new Date();
                } else if (type === 3) {
                  this.comm.observationDate = new Date();
                }
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        });
      },
      checkReasonBeforeConfirm() {
        if (!this.comm.rejectReason) {
          this.$message({
            type: "error",
            message: this.$t('Səbəb_yazılmayıb'),
          });
          return;
        }
        this.accidentStatus === 11 ? this.confirm(2) : this.accidentStatus === 13 ? this.confirm(3) : null;
      },
      checkChangeCommBeforeConfirm() {
        let errorMessage = null;

        if (!this.comm.reason) {
          errorMessage = this.$t('Səbəb_yazılmayıb');
        } else if (!this.accidentCommUid) {
          errorMessage = this.$t('Qəza_komissarı_seçilməyib');
        }

        if (errorMessage) {
          this.$message({
            type: "error",
            message: errorMessage
          });
          return;
        }

        this.onCommUnSign();
      },

      newParticipant() {
        this.$refs["participant"].new(this.comm.accidentId);
      },
      newOtherParticipant() {
        this.$refs["otherParticipant"].new(this.comm.accidentId);
      },

      openMap(context) {
        this.context = context;
        if (context === 'place') {
          this.$refs["mapcontrol"].show(this.comm.lat, this.comm.lng);
        } else if (context === 'obs') {
          this.$refs["mapcontrol"].show(this.comm.obsLat, this.comm.obsLng);
        }
      },

      coordChanged(val) {
        if (this.context === 'place') {
          this.comm.lat = val.lat;
          this.comm.lng = val.lng;
          this.comm.commPlace = val.placeName;
          this.comm.location = val.lat.toString() + ", " + val.lng.toString();
        } else if (this.context === 'obs') {
          this.comm.obsLat = val.lat;
          this.comm.obsLng = val.lng;
          this.comm.observationPlace = val.placeName;
          this.comm.obsLocation = val.lat.toString() + ", " + val.lng.toString();
        }
      },
      onStart() {
        this.$confirm(this.$t('Hadisə_üzrə_iş_başlandı'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          this.commloading = true
        console.log(this.comm)
         if (!this.comm || !this.comm.id) {
            CreateCommData(this.id, this.uid).then((response) => {
              this.commloading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: this.$t('Uğurlu_əməliyyat'),
                  });
                  this.getData();
                  this.getCommData();
                  this.getParticipants();
                }
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Səhv_əməliyyat'),
                });
              }
            });
          } else {
            AccidentCommStart(this.id, this.uid).then((response) => {
              this.loading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: this.$t('Uğurlu_əməliyyat'),
                  });
                  this.getData();
                }
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Səhv_əməliyyat'),
                });
              }
            });
          }


        });
      },
      onResetForm() {
        this.$confirm(this.$t('Qeyd_edilən_məlumatlar_silinəcək'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          this.commloading = true;
          this.resetForm();
          this.commloading = false;
        });
      },
      radioChange(type) {
        let commChainAccidentOld = this.comm.commChainAccident;
        let commInjuredOld = this.comm.commInjured;

        if (type === 'zbt') {
          if (this.comm.zbt === 1) {
            this.comm.commChainAccident = 0;
            this.comm.commInjured = 0;
            this.comm.vehicleCount = 2;
          }
        } else if (type === 'commChainAccident') {
          this.comm.zbt = 0;
          this.comm.commChainAccident = commChainAccidentOld;
        } else if (type === 'commInjured') {
          this.comm.zbt = 0;
          this.comm.protocol = 0;
          this.comm.commInjured = commInjuredOld;
        } else {
          this.comm.commChainAccident = commChainAccidentOld;
          this.comm.commInjured = commInjuredOld;
        }
        this.updateRequiredStatus();
      },
      updateRequiredStatus() {
        Object.keys(this.rules).forEach(key => {
          this.rules[key][0].required = true;
        });

        if (this.comm.zbt) {
          this.rules.commChainAccident[0].required = false;
          this.rules.commInjured[0].required = false;
        }
        if (this.comm.commChainAccident) {
          this.rules.zbt[0].required = false;
        }
        if (this.comm.commInjured) {
          this.rules.zbt[0].required = false;
          this.rules.protocol[0].required = false;
        }
      }
      ,

      lastAccidentStatus() {
        LastAccidentStatus(this.id).then((response) => {
          if (response) {
            this.accidentStatus = response.data;
          } else {
            this.$message({
              type: "warning",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      },
      rejectComm(type) {
        this.comm.rejectType = type;
        this.comm.commandUserId = this.uid;
        const handleResponse = (response) => {
          this.commloading = false;

          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0] ? response.data.errors[0] : this.$t('Səhv_əməliyyat'),
              });
            } else {
              if (type === 1) {

                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });

              }
              this.getData();
            }
          } else {
            this.$message({
              type: "error",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        }

        if (type === 1) {
          this.$confirm(this.$t('Tələbdən_imtina_edilir'), this.$t('Təsdiqləyin'), {
            confirmButtonText: this.$t('Bəli'),
            cancelButtonText: this.$t('Xeyr'),
            type: "info",
          }).then(() => {
            this.comm.finishDate = new Date();
            this.comm.commandUserId = this.uid;
            UpdateCommData(this.comm).then(handleResponse);
            this.$router.push('/comm/main')

          }).catch(() => {
            this.commloading = false;
          });
        } else {
          this.comm.commandUserId = this.uid;
          UpdateCommData(this.comm).then(handleResponse);
          this.getData();
        }
      }
      ,

      resetForm() {
        this.resetFields().then(() => {
          this.comm.commAccidentDate = null;
          this.comm.departureDate = null;
          this.comm.leaveDate = null;
          this.comm.observationDate = null;
          this.comm.finishDate = null;
          this.comm.commPlace = null;
          this.comm.observationPlace = null;
          this.comm.needDeparture = 1;
          this.comm.regionId = 1;
          this.save();
        });
      },
      resetFields() {
        return new Promise((resolve) => {
          this.$nextTick(() => {
            this.$refs["comm"].resetFields();
            resolve();
          });
        });
      },
    getCommData() {
  this.commloading = true;

  GetCommData(this.id).then((response) => {
    this.commloading = false;
    
    // response.data ve response.data.data?.[0] null kontrolü
    if (response && response.data && response.data.data && response.data.data?.[0]) {
      this.comm = response.data.data?.[0];
    } else {
      // Boş bir nesne oluştur, hiçbir zaman null olmasın
      this.comm = {};
    }
    
    console.log(this.comm);
    this.$nextTick(() => {
      if (this.$refs.comm) {
        this.$refs.comm.clearValidate();
      }
    });
  });
},
      handleCommand(command) {
        let id = command.id;
        if (command.action === "comm") this.handleCommSend(command.id);
        if (command.action === "user") this.handleUser();
      },
      sendToCommApproval(id) {
        this.$confirm(this.$t('Müraciət_təsdiqə_göndərilsin'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        })
          .then(() => {
            this.loading = true;
            if (this.comm.checkReportStatus === 0 && this.comm.policyType && this.comm.policyType === 1) {
              this.$message({
                type: "warning",
                message: this.$t('Raport_qeyd_olunmayıb'),
              });
              this.loading = false;
              return;
            }

            SendToCommApproval(id, this.uid).then((response) => {
              this.loading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: this.$t('Təsdiqə_göndərildi'),
                  });
                  this.getData();
                  this.$router.push('/comm/main');
                }
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Səhv_əməliyyat'),
                });
              }
            });
          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },

      handleCommSend() {
        let id = this.comm.accidentId;
        this.checkStatusCount(id).then(() => {
          if (this.statusCount > 0) {
            this.$message({
              type: "warning",
              message: this.$t('Daha_öncə_Müştəri_xidmətinə_göndərilib'),
            });
          }
          else {
            if (this.comm.leaveDate || this.comm.needDeparture === 2) {
              this.$confirm(this.$t('Müraciət_Müştəri_xidmətinə_göndərilsin'), this.$t('Təsdiqləyin'), {
                confirmButtonText: this.$t('Bəli'),
                cancelButtonText: this.$t('Xeyr'),
                type: "info",
              })
                .then(() => {
                  this.loading = true;
                  SendToClientService(id, this.uid).then((response) => {
                    this.loading = false;
                    if (response.data) {
                      if (!response.data.isSuccess) {
                        this.$message({
                          type: "error",
                          message: response.data.errors[0],
                        });
                      } else {
                        this.$message({
                          type: "success",
                          message: this.$t('Müştəri_xidmətinə_göndərildi'),
                        });
                        this.getData();
                        this.$router.push('/adm/commapprove');
                      }
                    } else {
                      this.$message({
                        type: "error",
                        message: this.$t('Səhv_əməliyyat'),
                      });
                    }
                  });
                })
                .catch(() => {
                  this.loading = false;
                  this.$message({
                    type: "info",
                    message: "Xitam verildi",
                  });
                });

            }
            else {
              if (this.comm.needDeparture === 1)
                this.$message({
                  type: "warning",
                  message: this.$t('Hadisə_yerindən_ayrılma_vaxtı_qeyd_olunmayıb'),
                });
            }

          }
        });
      },
      checkStatusCount(id) {
        this.statusCount = 0;
        return new Promise((resolve, reject) => {
          CheckStatusCount(id, 0, 30).then((response) => {
            if (response.data) {
              this.statusCount = response.data.data;
            }
            resolve(this.response);
          }, error => {
            reject(error);
          })
        })
      },


      saveClick() {
        this.$refs["comm"].validate((valid) => {
          if (!valid) {
            this.$message({
              type: "warning",
              message: this.$t('Məlumatların_tam_və_düzgün_olmasını_yoxlayın'),
            });
            return false;
          } else if (this.comm.needDeparture === 1 && !this.comm.leaveDate) {
            this.$message({
              type: "warning",
              message: this.$t('Ayrılma_vaxtı_qeyd_olunmayıb'),
            });
            return false;
          } else {
            this.loading = true;
            this.fetchFiles();
          }
        });
      },
      async fetchFiles() {
        this.loading = true;
        try {
          const files = await GetFiles(1, this.comm.id, null, this.uid);

          if (!files.data.data || files.data.data.length < 1) {
            this.$message({
              type: "warning",
              message: this.$t('Ən_azı_bir_fayl_yüklənməlidir'),
            });
          } else {
            this.save(files);
          }
        } catch (error) {
          console.error("Error fetching files:", error);
        } finally {
          this.loading = false;
        }
      },

      handleClick() {
        if (this.item.policyType === null || this.item.policyType === 1) {
          this.newParticipant();
        } else {
          this.newOtherParticipant();
        }
      },
      save(fileUploaded) {
        this.comm.commandUserId = this.uid;
        if (!this.comm.finishDate) {
          this.comm.finishReason = null;
          this.comm.finishNote = null;
        }
        if (this.comm.commAccidentDate) {
          this.comm.departureDate = DateTimeToJson(this.comm.departureDate);
          this.comm.leaveDate = DateTimeToJson(this.comm.leaveDate);
          this.comm.observationDate = DateTimeToJson(this.comm.observationDate);
          this.comm.commAccidentDate = DateTimeToJson(this.comm.commAccidentDate);
          UpdateCommData(this.comm).then((response) => {
            this.commloading = true;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0]
                    ?  response.data.errors[0]
                    : this.$t('Səhv_əməliyyat'),
                });
                this.commloading = false;
              } else {
                // this.$message({
                //   type: "success",
                //   message: this.$t('Uğurlu_əməliyyat'),
                // });
                this.getData()
                this.commloading = false;
                if (fileUploaded) {
                  this.sendToCommApproval(this.comm.accidentId);
                }
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        }
        else {
          this.commloading = false;
          this.$message({
            type: "info",
            message: "Xitam verildi",
          });
        }

      },

      accidentDateSave() {
        this.comm.commandUserId = this.uid;
        if (this.comm.commAccidentDate)
          this.comm.commAccidentDate = DateTimeToJson(this.comm.commAccidentDate);
        if (!this.comm.finishDate) {
          this.comm.finishReason = null;
          this.comm.finishNote = null;
        }
        UpdateCommData(this.comm).then((response) => {
          this.commloading = false;
          if (response.data) {
            if (!response.data.isSuccess) {

            } else {

            }
          } else {

          }
        });
      },
      getData() {

        this.loading = true;
        GetAccident(this.id).then((response) => {
          this.loading = false;
          if (response.data) {
            this.item = response.data.data?.[0];
            this.getCommSchedule();
            this.getCommData();
            this.getParticipants();
            this.lastAccidentStatus();

          } else {
            this.$message({
              type: "warning",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });

      },
      getParticipants() {
        this.partloading = true;
        this.loading = true;
        GetParticipants(this.id).then((response) => {

          if (response.data.data) {
            this.participants = response.data.data;
          }
          this.partloading = false;
          this.loading = false;
          this.getCommData();
        });
      },
      handleUser() {
        this.$refs["user"].edit(this.item);
      },
      editParticipant(id) {
        if (this.item.policyType === 1 && this.item.policyType)
          this.$refs["participant"].edit(id, this.isFormDisabled);
        else
          this.$refs["otherParticipant"].edit(id, this.isFormDisabled);

      },
      reportParticipant(id, accidentId, createUserId) {
        this.$refs["report"].edit(id, accidentId, createUserId, this.isFormDisabled);
      },
      deleteParticipant(id) {
        this.$confirm(this.$t('ştirakçı_ləğv_olunsun'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "error",
        })
          .then(() => {
            this.loading = true;
            DeleteParticipant(id, this.uid).then((response) => {
              this.loading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0]
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: this.$t('Ləğv_olundu'),
                  });
                  this.getParticipants();
                }
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Səhv_əməliyyat'),
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },
      openChangeCommDialog() {
        this.changeCommVisible = true;
      },

      onCommUnSign() {
        let commUnSign = new CommUnsign();
        commUnSign.commandUserId = this.uid;
        commUnSign.commId = this.comm.id;
        commUnSign.accidentId = this.comm.accidentId;
        commUnSign.commUid = this.accidentCommUid;
        commUnSign.reason = this.comm.reason;

        CreateCommUnSign(commUnSign).then((response) => {
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0],
              });
            } else {
              this.$message({
                type: "success",
                message: this.$t('Təyinat_dəyişdirildi'),
              });

              this.changeCommVisible = false;
              this.$router.push('/comm/main');
              this.commNotification = { accidentId: commUnSign.accidentId, insuranceType: 1, commUid: commUnSign.commUid, mailType: 2 };

              let acc = Object.assign({}, this.commNotification);
              SendNewAccidentToComm(acc)
                .then(response => {
                })
                .catch(error => {
                });
            }
          } else {
            this.$message({
              type: "error",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      }
      ,
      updateLabelWidth() {
        if (window.innerWidth <= 1024) {
          this.labelWidth = '120px';
        } else {
          this.labelWidth = '210px';
        }
      }
    },
    watch: {
      'comm.finishReason': function (newValue, oldValue) {
        if (newValue !== null && newValue !== oldValue) {
          this.comm.finishDate = new Date();
        }
      },
      logs: {
        immediate: true,
        deep: true,
        async handler(newLogs) {
          this.processedLogDiffs = await processLogDiffs(newLogs, this.methodNames);
        }
      }
    },
    mounted() {
      this.getData();
      this.getCommUnSign();
      this.getCommReject();
    },
    created() {
      this.updateLabelWidth();
      window.addEventListener('resize', this.updateLabelWidth);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateLabelWidth);
    }
  };
</script>



<style lang="scss">
  .row-with-spacing>div {
    margin-bottom: 20px;
  }

  @media (max-width: 1024px) {
    .responsive-row {
      flex-direction: column;
    }
  }

  .card-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .mb-2,
  .my-2 {
    margin-bottom: 0 !important;
  }

  .el-collapse {
    border-top: none !important;
    border-bottom: none !important;
  }

  .el-collapse-item__wrap {
    border-bottom: none !important;
  }

  .el-collapse-item__content {
    padding: 0 !important;
  }
</style>